import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import './Css/tokens.css';
import './Css/Custom.css';
import ScrollToTop from "./Components/withScrollReset";
import Home from "./Components/Home";
import TermsofServices from "./Components/Terms of Services";
import PrivacyPolicy from "./Components/Privacy Policy";
import AllPages from "./MainPages/AllPages";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Terms of Services" element={<TermsofServices />} />
            <Route path="/Privacy Policy" element={<PrivacyPolicy />} />
            <Route path="/*" element={<AllPages />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
